import {actionTypes} from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const get4DResult=(id,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_4D_RESULT_START
    })
    const options={
        url:`${api}/fourDResults/${id}`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        }
    }
    await axios(options)
        .then(response=>dispatch({
            type:actionTypes.GET_4D_RESULT_SUCCESS,
            payload:response.data
        }))
        .catch(error=>dispatch({
            type:actionTypes.GET_4D_RESULT_FAIL,
            payload:getMessage(error)
        }))
}